import { http } from './config'

export default {
  
  getAllProductLines: () => {
    return http.get('product_lines')
  },

  getFilteredProductLines: (params) => {
    return http.get('product_lines', {params})
  },

  getProductLineById: (productLineId) => {
    return http.get('product_lines/' + productLineId)
  },

  getProductLineByName: (name) => {
    return http.get('product_lines/search_by_name/' + name)
  },

  createProductLine: (productLineParams) => {
    return http.post('product_lines', {
      name: productLineParams.name
    }
  )},

  updateProductLine: (productLineParams) => {
    return http.put('product_lines/' + productLineParams.productLineId, {
      name: productLineParams.name
    }
  )},

  deleteProductLine: (productLineId) => {
    return http.delete('product_lines/' + productLineId)
  },
}
